import { useEmailByOobCodeQuery } from 'shared/hooks/queries/use-email-by-oob-code-query';

export const useEmailByOobCode = (oobCode?: string) => {
  const { data } = useEmailByOobCodeQuery(oobCode);

  return data ?? undefined;
};
